<template>
  <div class="container p-d-flex p-flex-column p-ai-center p-justify-center">
    <div class="faq-box">
      <div class="faq-title"> FAQ</div>
      <div v-for="(item, index) of items" :key="index" class="p-mt-6">
        <div class='p-d-flex p-ai-center p-mt-4 adjust' @click='toggleAccordion(index)'>
          <i v-if='item?.isExpanded' class="material-icons p-justify-start">remove</i>
          <i v-else class="material-icons p-justify-start">add</i>
          <span class='p-flex-column acc-header'>{{ item.header }}</span>
        </div>
        <div :class="item?.isExpanded ? 'show' : ''" class="accordion-content">
          <p class="accordion-content-text" v-html="item.content"></p>
        </div>
        <div class='line'></div>
      </div>
      <template>
        <div class='back p-mt-6' @click="$emit('update:isShow', false)">Back</div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
export default {
  props: {
    isShow: Boolean,
  },
  setup(props, ctx, emit) {
    const modal = () => {
      ctx.emit('memberModalClose');
    };
    const items = ref([
      {
        header: 'How can I get started?',
        content: 'Once you have registered as a creator you are free to check out all the available campaigns and see ' +
          'which ones look like the best fit for your channel! If you need further help, you can check out the ' +
          'tutorial for the site by clicking on the <strong>?</strong> in the bottom left.',
        isExpanded: false
      },
      {
        header: 'What kind of ad do I need to do in my videos?',
        content: 'The length and style of the ad is entirely up to you, however, you of course want to make it as ' +
            'high quality as possible to generate the most downloads. Some of the most popular formats are:<br><br>' +
            '<b>30-60 second pre-roll:</b> a short ad showing off the game using the assets and talking ' +
            'points provided.<br><br>' +
            '<b>Dedicated video:</b> an entire video of you playing the game, this type ' +
            'of ad tends to work best when the game fits the style of your channel. Videos of you playing the game will ' +
            'also best attract the attention of the developer to offer to purchase licensing of your video.<br><br>' +
            '<b>10-30 second end-roll:</b> a short ad placed at the end of your video, quickly showing off the ' +
            'assets and mentioning a couple of the talking points.' +
            'You can also share your personalised download link across all of your social media to increase your reach!',
        isExpanded: false,
      },
      {
        header: 'What is the advanced licensing creator program? (Selling the license to your ads)',
        content: 'One of the benefits of gameinfluencer.io is the ability to earn extra revenue by allowing the ' +
            'license to your ads to be sold directly to the developers.<br><br>With our program you can sell licenses to ' +
            'each of the content pieces you manage to create and distribute to the brands.<br><br>This way you can allow' +
            ' your creator ads to be featured for additional licensing which will grant the brand the<strong>right to ' +
            'publish the video content of your creator ads on their own media channels' +
            ', such as TV, Google marketing campaigns etc.,</strong>' +
            'earning you a specific amount.<br><br>If the brand is interested in additional licensing you will receive ' +
            'a request notification on your account outlining their desired terms for the additional license.',
        isExpanded: false,
      }, {
        header: 'What is CPI, CPC, and CPM?',
        content: 'The campaigns on gameinfluencer.io work on either a CPI, CPC, or CPM basis.<br><br>' +
            '<strong>CPI:</strong> Cost Per Install works using the number of installs a game or app gets through your' +
            ' specific tracking link.' +
            ' The CPI for each campaign will be different, as well as the CPI for Android vs IOS devices, you can see' +
            ' these when going through the campaign preview.<br><br>' +
            '<strong>CPC:</strong> Cost per Click works by counting the number ' +
            'of clicks on the personalised tracking link. This link will take the user to the landing/home page of the ' +
            'game, and you will be paid out per click. CPC rates tend to be lower than CPI rates, but clicks are far easier ' +
            'to acquire than downloads.<br><br>' +
            '<strong>CPM:</strong> Cost-per-Mille values the number of views your sponsored video gets, with a rate per 1000 views. ' +
            'The views are tracked and paid out for the first 30 days that the video is live - all future views ' +
            'will not be counted. This is beneficial to you as it allows you to gauge how much you would be likely ' +
            'to earn from posting a sponsored video.<br><br>' +
            'It is important to note that each of these pricing models has its own advantages and disadvantages,' +
            ' and what works best for a particular campaign will depend on various factors such as the goals, ' +
            'target audience, budget, and type of product or service being advertised.',
        isExpanded: false,
      },{
        header: 'Is my channel too small to take part in campaigns?',
        content: 'No, there is no minimum size requirement for influencers to take part in campaigns on' +
          ' G.IO.<br><br> G.IO is designed to enable creators of all sizes to monetize their content' +
          ' and earn from their passion. So, whether you have a small, medium, or large following, ' +
          'you can participate in campaigns and earn from them simultaneously.<br><br> Don`t let the size of your channel hold' +
            ' you back from earning money through sponsorships and collaborations!'
      },
      { header: 'Can I take part in multiple campaigns?',
        content: 'Of course, you can participate in as many campaigns as you would like and earn from them all ' +
          'simultaneously. ' , isExpanded: false },
      { header: 'How does payment work?',
        content: 'Payouts occur once a month. Creators will need to reach a minimum of $100 earned per 30-day cycle to ' +
          'activate their payout; if the payout limit is not reached then this amount will carry over to the following ' +
          'month and will accumulate.' , isExpanded: false },
    ]);
    const toggleAccordion = (index) => {
      items.value[index].isExpanded = !items.value[index].isExpanded;
    };
    return { modal, toggleAccordion, items };
  },
};
</script>
<style scoped lang="scss">
.faq-box {
  padding-bottom: 135px;
  height: auto;
  max-width: 1600px;
  width: 100%;
  overflow: hidden;
}

.container {
  width: 100%;
  padding: 0px 30px;
}

.acc-header {
  font-style: normal;
  color: #FFFFFF;
  width: 1000px;
  margin-left: 1%;
  margin-top: 2px;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  max-width: 85%;
}

.acc-header:hover {
  text-decoration: underline;
}

.accordion-content {
  max-height: 0px;
  height: max-content;
  overflow: hidden;
  transition: all .7s;
}

.show {
  max-height: 1000px;
}

.accordion-content-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  margin-top: 20px;
  color: #FFFFFF;
  margin-left: 97px;
  border-left: solid red 3px;
  padding-left: 20px;
  width: 68%;
}

.line {
  border: 1px solid #898989;
  margin-top: 20px;
  width: 70%;
}

.back {
  font-weight: 800;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  cursor: pointer;
  color: #8B8F8F;
  text-align: left;
  margin-left: 50px;
}

h1 {
  margin-left: 500px;
}

.adjust {
  cursor: pointer;
  color: #E6443C;
}

.faq-title {
  font-size: 36px;
  line-height: 44px;
  color: #FFFFFF;
  padding-top: 5%;
  font-weight: 700;
}
@media screen and (max-width: 1000px) {
  .faq-title {
    text-align: center;
    font-size: 28px;
  }
  .material-icons {
    font-size: 18px;
  }
  .acc-header {
    font-size: 14px;
    margin-top: -2px;
  }
  .accordion-content-text {
    font-weight: 400;
    font-size: 10px;
  }
  .line {
    margin-top: 8px;
  }
  .faq-box {
    padding-bottom: 40px;
  }
}

@media screen and (max-width: 767px) {
  .accordion-content-text {
    margin-left: 30px;
    width: 80%;
  }
}
</style>
